import * as Yup from 'yup'

export const initialValues = {
  deliveryTicket: ''
}

export const validationSchema = Yup.object({
  deliveryTicket: Yup.string()
    .matches(/^[A-Za-z0-9]+$/, 'Valoare invalidă pentru bon de livrare.')
    .required('Acest camp este obligatoriu.')
})
